module.exports = __webpack_public_path__ + "static/media/milxc.53440d85.png";